export const TOP = 'top';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const LEFT = 'left';

export const placementsMap = {
    TOP,
    RIGHT,
    BOTTOM,
    LEFT,
};

export const placementsList = [TOP, RIGHT, BOTTOM, LEFT];
